var E = /* @__PURE__ */ ((L) => (L.DOB = "DOB", L.USDC = "USDC", L.sellToken = "sellToken", L.UHODL = "uHODL", L.SellTokenHODL = "sellTokenHODL", L.WETH = "WETH", L.USNIPER = "uSNIPER", L.SellTokenSNIPER = "sellTokenSNIPER", L.UBULLET = "uBULLET", L.SellTokenBULLET = "sellTokenBULLET", L))(E || {});
export {
  E as BaseTokenSymbol
};
//# sourceMappingURL=token_provider.mjs.map
